import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import lapChildDownloadIcon from 'images/brands/empresaunida/icons/ic-child-in-arms-download.png';

/**
 * LapChildDownloadButton component.
 * Render an outlined green button that links to the lap-child ticket PDF.
 * Used on PurchaseComplete per leg when the purchase carries a lap child.
 * @param {object} props - href.
 * @param {string} props.href - URL of the lap-child ticket PDF.
 * @returns {JSX.Element} The outlined download link.
 */
const LapChildDownloadButton = ({ href }) => {
  const { t } = useTranslation('purchase');

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 px-6 py-3 border-2 border-success-regular text-success-regular rounded-full font-semibold no-underline hover:bg-success-regular/5 transition-colors self-start"
    >
      <img src={lapChildDownloadIcon} alt="" className="w-7 h-7" />
      <span>{t('label.download_lap_child_ticket')}</span>
    </a>
  );
};

LapChildDownloadButton.propTypes = {
  /** URL of the lap-child ticket PDF */
  href: PropTypes.string.isRequired,
};

export default LapChildDownloadButton;
